function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

import ContractFormFeatures from '@engine/components/presentational/contract-form/contract-form-features';
import React from 'react';
import { connect } from 'react-redux';
import { setContractFormFeature } from '@engine/actions/creators/contract-form';

var ContractFormFeaturesContainer = /*#__PURE__*/function (_React$Component) {
  _inherits(ContractFormFeaturesContainer, _React$Component);

  var _super = _createSuper(ContractFormFeaturesContainer);

  function ContractFormFeaturesContainer() {
    var _this;

    _classCallCheck(this, ContractFormFeaturesContainer);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));
    _this.state = {
      selectAll: false
    };

    _this.handleSelectAllToggle = function () {
      var allFeatures = _this.props.allFeatures;
      var selectAll = _this.state.selectAll;

      _this.setState({
        selectAll: !selectAll
      });

      _this.props.setContractFormFeature(selectAll ? [] : allFeatures);
    };

    _this.handleToggle = function (event) {
      _this.props.setContractFormFeature(event.target.value);
    };

    return _this;
  }

  _createClass(ContractFormFeaturesContainer, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.props.setContractFormFeature(this.props.defaultFeatureValues);
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props = this.props,
          allFeatures = _this$props.allFeatures,
          supportedFeaturesWithTooltip = _this$props.supportedFeaturesWithTooltip,
          features = _this$props.features;
      return React.createElement(ContractFormFeatures, {
        features: features,
        setFeatureValue: this.props.setContractFormFeature,
        allFeatures: allFeatures,
        supportedFeaturesWithTooltip: supportedFeaturesWithTooltip,
        handleToggle: this.handleToggle,
        handleSelectAllToggle: this.handleSelectAllToggle
      });
    }
  }]);

  return ContractFormFeaturesContainer;
}(React.Component);

var mapStateToProps = function mapStateToProps(state) {
  return {
    features: state.contractFormReducer.features
  };
};

var mapDispatchToProps = {
  setContractFormFeature: setContractFormFeature
};
export default connect(mapStateToProps, mapDispatchToProps)(ContractFormFeaturesContainer);